import { useAsyncValue, useSearchParams } from "react-router-dom";

import { Field, Label } from "@/components/fieldset";
import { Select } from "@/components/forms";
import { InputGroup } from "@/components/input";
import { formatPrice } from "@/utils/format-price";

const PlanOption = ({ plan }) => {
  return (
    <option key={plan.price_id} value={plan.price_id}>
      {plan.nickname} {formatPrice(plan.unit_amount / 100)}{" "}
      {plan.interval === "year" && "(-20%)"}
    </option>
  );
};

export default function PlanSelector() {
  let [searchParams] = useSearchParams();
  const prices = useAsyncValue();
  const monthlyPlans = prices.filter((price) => price.interval === "month");
  const yearlyPlans = prices.filter((price) => price.interval === "year");
  const priceId = searchParams.get("priceId");

  return (
    <Field className="w-full">
      <Label>Select your plan</Label>
      <InputGroup>
        <Select name="priceId" defaultValue={priceId}>
          <optgroup label="Monthly">
            {monthlyPlans.map((plan) => (
              <PlanOption key={plan.price_id} plan={plan} />
            ))}
          </optgroup>

          <optgroup label="Yearly">
            {yearlyPlans.map((plan) => (
              <PlanOption key={plan.price_id} plan={plan} />
            ))}
          </optgroup>
        </Select>
      </InputGroup>
    </Field>
  );
}
